// Locale switcher refs:
// - Paraglide docs: https://inlang.com/m/gerre34r/library-inlang-paraglideJs
// - Router example: https://github.com/TanStack/router/tree/main/examples/react/i18n-paraglide#switching-locale
import { CustomSelect } from '@/shared/ui'
import type { LocaleType } from '@/shared/types'
import { useTranslation } from 'react-i18next'

export function LocaleSwitcher() {
  const { i18n, t } = useTranslation()
  const currentLocale = i18n.language
  const options: { label: string; value: LocaleType }[] = [
    { label: 'RU', value: 'ru' },
    { label: 'UZ (Lotin)', value: 'uz' },
    { label: 'UZ (Кирилл)', value: 'uz-Cyrl' },
  ]

  return (
    <div
      style={{
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'center',
        color: 'inherit',
      }}
      aria-label={t('language_label')}
    >
      <div style={{ display: 'flex', gap: '0.25rem' }}>
        <CustomSelect
          value={[currentLocale as LocaleType]}
          options={options}
          width="150px"
          onChange={(value: LocaleType[]) => {
            const locale = value[0]
            i18n.changeLanguage(locale)
            localStorage.setItem('appLng', locale)
          }}
        />
      </div>
    </div>
  )
}
